import appSettings from 'wanderu-config';
import { fetchCachedTripsAction as fetchCachedTripsPsearchAction } from 'wanderu-ducks-psearch';
import Logger from 'wanderu-logger';
import { SnowplowService } from 'wanderu-service-analytics';
import { getDateRange } from 'wanderu-utils';

import {
    actions,
    namespace,
    reducer,
    selectors,
} from './base';
import { actions as filterActions } from '../../appstate/filters';
import {
    actions as searchActions,
    selectors as searchSelectors,
} from '../../appstate/search';
import { DEPART_DIRECTION } from '../../constants';
import { serializeFilterParams } from '../../utils';

const logger = Logger.getLogger('search-fetch-cached-trips');

function fetch(searchParams, serverBatchId, urlProps) {
    return async (dispatch, getState) => {
        dispatch(actions.startWork(searchParams));

        if (serverBatchId) {
            dispatch(searchActions.setServerBatchId(serverBatchId));
        }

        let error;
        let meta = {};

        try {
            const psearchParams = {
                ...searchSelectors.selectPSearchParams(getState(), searchParams),
                batchId: searchParams.batchId || serverBatchId,
            };

            const promises = [];
            const dates = getDateRange(psearchParams.departDatetime);

            dates.forEach(({ date, isDisabled }) => {
                if (!isDisabled) {
                    const newPsearchParams = psearchParams.direction === DEPART_DIRECTION
                        ? { ...psearchParams, departDatetime: date }
                        : { ...psearchParams, returnDatetime: date };

                    promises.push(dispatch(fetchCachedTripsPsearchAction.fetch(newPsearchParams)));
                }
            });

            await Promise.allSettled(promises);

            const urlFilterParams = searchSelectors.selectUrlFilterParams(
                { location: urlProps?.location || window?.location },
                searchParams.direction,
            );

            dates.forEach(({ date, isDisabled }) => {
                if (!isDisabled) {
                    const newSearchParams = serializeFilterParams({
                        ...searchParams,
                        departDate: date,
                    });

                    dispatch(filterActions.setFilterParams(
                        urlFilterParams,
                        newSearchParams,
                        searchParams?.direction
                    ));
                }
            });
        } catch (ex) {
            const domainUserInfo = appSettings.env.isClient
                ? SnowplowService.getDomainUserInfo()
                : {};

            logger.error('fetch', ex, {
                snowplowIds: {
                    networkUserId: SnowplowService.getNetworkUserId(),
                    ...domainUserInfo,
                },
            });

            error = {
                code: ex.code,
                message: ex.message,
                name: ex.name,
            };
        } finally {
            dispatch(actions.endWork(searchParams, meta, error));
        }
    };
}

function reset(searchParams) {
    return (dispatch, getState) => {
        const psearchParams = searchSelectors.selectPSearchParams(getState(), searchParams);
        dispatch(fetchCachedTripsPsearchAction.reset(psearchParams));
        dispatch(actions.reset(searchParams));
    };
}

function expire(opts) {
    return actions.expire(opts);
}

const fetchCachedTripsAction = {
    expire,
    fetch,
    reset,
    ...selectors,
};

export {
    fetchCachedTripsAction,
};

export default {
    [namespace]: reducer,
};
